import env from "Consts/env";
import Cookies from "js-cookie";
import { handle498OnClient } from "Helpers/is498";
import { apiSlice } from "../api/apiSlice";

export const searchApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getSearchDefault: builder.query({
			query: () => ({
				url: "/api/fds-search/default",
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
			providesTags: ["Search"],
		}),
		getSearchQuick: builder.query({
			query: (args) => ({
				url: "/api/fds-search/quick",
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
					keyword: encodeURIComponent(args.keyword),
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
		}),
		getSearchCampaign: builder.query({
			query: () => ({
				url: "/api/fds-search/campaign",
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
		}),
		submitSearchHistory: builder.mutation({
			query: (body) => ({
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
				},
				url: "/api/fds-search/submitHistory",
				method: "POST",
				body,
			}),
			invalidatesTags: ["Search"],
		}),
		deleteOneHistory: builder.mutation({
			query: (body) => ({
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
				},
				url: "/api/fds-search/deleteHistory",
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["Search"],
		}),
		clearAllHistory: builder.mutation({
			query: () => ({
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
				},
				url: "/api/fds-search/clearHistory",
				method: "PATCH",
			}),
			invalidatesTags: ["Search"],
		}),
		getSearchResultProduct: builder.query({
			query: (params) => ({
				url: "/api/fds-search/result/products",
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
					key: process.env.NEXT_PUBLIC_KEY_API_CLIENT,
				},
				params: {
					...params,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return {
					status: response?.status ?? response.meta.code,
					data: response?.data?.results?.products,
					pagination: response?.pagination,
				};

			},
			providesTags: ["SEARCH_RESULT_PRODUCT"],
		}),
		getSearchResultBrand: builder.query({
			query: (params) => ({
				url: "/api/fds-search/result/brands",
				headers: {
					...env.HEADERS,
					authorization: Cookies.get("token") ?? "",
					key: process.env.NEXT_PUBLIC_KEY_API_CLIENT,
				},
				params: {
					...params,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
			providesTags: ["SEARCH_RESULT_BRAND"],
		}),
		getSearchFilterList: builder.query({
			query: () => ({
				url: "/api/fds-sort",
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
		}),
		getSearchResultRecomendation: builder.query({
			query: (params) => ({
				url: "/api/fds-search/result/recommendations",
				headers: {
					...env.HEADERS,
					key: process.env.NEXT_PUBLIC_KEY_API_CLIENT,
				},
				params: {
					...params,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return {
					status: response?.status ?? response.meta.code,
					data: response?.data?.results?.products,
					pagination: response?.pagination,
				};

			},
			providesTags: ["SEARCH_RESULT_PRODUCT_RECOMEND"],
		}),
	}),
});

export const {
	useLazyGetSearchDefaultQuery,
	useLazyGetSearchQuickQuery,
	useGetSearchCampaignQuery,
	useDeleteOneHistoryMutation,
	useClearAllHistoryMutation,
	useSubmitSearchHistoryMutation,
	useLazyGetSearchResultRecomendationQuery,
	useGetSearchResultRecomendationQuery,
	useGetSearchResultProductQuery,
} = searchApiSlice;
